// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f54456a4","977":"0e5b9ff0"}[chunkId] + ".chunk.js";
};